const getValue = (obj) => {
  if (typeof obj === 'object') {
    return obj.value || ''
  } else {
    return obj || '';
  }
}

export {
  getValue
}


export default (opt) => {
  const {
    titleText, titleSize, titleColor, titleWeight,
    subTitleText, subTitleSize, subTitleColor, subTitleWeight
  } = opt;
  return {
    title: {
      text: getValue(titleText),
      textStyle: {
        fontSize: getValue(titleSize),
        color: getValue(titleColor),
        fontWeight: getValue(titleWeight) ? 600 : 400
      },
      left: 'center',
      subtext: getValue(subTitleText),
      subtextStyle: {
        fontSize: getValue(subTitleSize),
        color: getValue(subTitleColor),
        fontWeight: getValue(subTitleWeight) ? 600 : 400
      }
    },
    backgroundColor: 'rgba(0,0,0,0)',
    grid: {
      top: 70,
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    toolbox: {
      show: true,
      orient: 'vertical',
      left: 'right',
      top: 'center',
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
        restore: { show: true },
        saveAsImage: { show: true }
      }
    }
  }
}


// WEBPACK FOOTER //
// src/chart/customBaseChart.js